'use client';
import { usePathname } from 'next/navigation';
import Link from 'next/link';
import { listNav } from 'libs/constants/nav';
import { clsx } from 'clsx';
import styles from './nav.module.scss';
import { useEffect, useState } from 'react';
import { Search } from '../search';
import { WidgetBlind } from '../widget-blind/widget-blind';
import { BurgerButton } from './burger-button/burger-button';

export const Nav = () => {
  /* Определяет страницу для подсветки пункта меню*/
  const activeLink = '/' + usePathname().split('/')[1];

  const [openMenu, setOpenMenu] = useState(false);
  const [showEye, setShowEye] = useState(false);
  const [hiddenInput, setHiddenInput] = useState(false);

  /* При условии что в мобильной версии открыто меню,
    у сайта не производится скролл */
  useEffect(() => {
    if (window.innerWidth < 640) {
      setShowEye(true);
    }
    const htmlTagElement = document.querySelector('html');
    if (openMenu) {
      htmlTagElement.classList.add('lock');
    } else {
      htmlTagElement.classList.remove('lock');
    }
  }, [openMenu]);

  const onClickBurger = () => {
    setOpenMenu(!openMenu);
  };

  return (
    <>
      <nav className={clsx(styles.nav, { [styles.active]: openMenu })}>
        {listNav.map(({ link, title }) => (
          <Link
            className={clsx(styles.link, {
              [styles.active]: activeLink === link,
            })}
            key={title}
            href={link}
            onClick={onClickBurger}
          >
            {title}
          </Link>
        ))}
        <li className={clsx(styles.link, styles.mobileButtonMenu)}>
          <Search
            onClickBurger={onClickBurger}
            hiddenInput={hiddenInput}
            setHiddenInput={setHiddenInput}
          />
        </li>
      </nav>
      {showEye && <WidgetBlind white={true} />}
      <BurgerButton openMenu={openMenu} onClickBurger={onClickBurger} />
    </>
  );
};
